// extracted by mini-css-extract-plugin
export default {"rowHasBadge":"Wj-z","carouselContainer":"Xj-z","carouselContent":"Yj-z"};